export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'

export const ACADEMIC_BASE_URL = 'https://brainware-india.net/bwu-buis-api/'
export const BASE_URL = 'https://brainwareuniversity.ac.in/'